/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import PropTypes from 'prop-types'
import { Alert as MaterialAlert, AlertTitle } from '@material-ui/lab'

export default function Alert(props) {
  const { title, children, ...rest } = props

  return (
    <MaterialAlert {...rest}>
      { title ? (
        <AlertTitle>{title}</AlertTitle>
      ) : null }
      { children }
    </MaterialAlert>
  )
}

Alert.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.object,
  ]).isRequired,
}

Alert.defaultProps = {
  title: '',
}
